import { Cell, Grid, Heading, HFlow, Icon } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { StatusInformation } from 'components/StatusInformation'
import { css } from 'emotion'
import { TipoReacaoAlergia } from 'graphql/types.generated'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { Alergia, categoriaAlergiaRecord } from 'view/atendimentos/detail/soap/aside/types/AlergiaModel'

import { AlergiaTag } from '../../AlergiaTag'

type HeaderAlergiaModalProps = {
  alergia?: Alergia
}

export function HeaderAlergiaModal(props: HeaderAlergiaModalProps) {
  const {
    alergia: {
      substanciaEspecifica,
      substanciaEspecificaLegado,
      categoriaSubstanciaEspecificaLegado,
      tipoReacao,
      ultimaEvolucao: { atualizadoEm },
      criticidade,
      grauCerteza,
    },
  } = props

  const categoriaAlergia =
    categoriaAlergiaRecord[substanciaEspecifica?.categoria ?? categoriaSubstanciaEspecificaLegado]
  const classes = createStyles()

  return (
    <div className={classes.iconContainer}>
      <Icon icon='angleDown' name='accordionAngleIcon' />
      <Grid
        gapVertical={0}
        style={css`
          width: 100%;
          padding-left: 16px;
        `}
        alignItems='flex-start'
      >
        <Cell size={6}>
          <HFlow hSpacing={0.5} alignItems='center'>
            <Heading level={4}>{substanciaEspecifica?.nome ?? substanciaEspecificaLegado}</Heading>
          </HFlow>
        </Cell>
        <Cell size={6}>
          <div className={classes.tagsContainer}>
            <AlergiaTag type='grauCerteza' enum={grauCerteza} />
            <AlergiaTag type='criticidade' enum={criticidade} />
          </div>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.5} alignItems='center'>
            {React.cloneElement(categoriaAlergia.icon, {
              style: { color: `${categoriaAlergia.color}`, flexShrink: 0 },
            })}
            <HLabel
              title={`${
                tipoReacao ? (tipoReacao === TipoReacaoAlergia.ALERGIA ? 'Alergia' : 'Intolerância') : 'Reação adversa'
              } a ${categoriaAlergia?.descricao}`}
            >
              {' | '}
            </HLabel>
            {atualizadoEm ? (
              <HLabel title='Última avaliação:'>{formatDate(atualizadoEm)}</HLabel>
            ) : (
              <StatusInformation icon='clockOutline' text='Avaliado agora' />
            )}
          </HFlow>
        </Cell>
      </Grid>
    </div>
  )
}

const createStyles = () => ({
  tagsContainer: css`
    display: flex;
    justify-content: flex-end;
    & > span {
      margin: 0 0 0.5rem 0.5rem;
    }
  `,
  iconContainer: css`
    display: flex;
    align-items: center;
  `,
})
